@let deliveryPostcode = this.deliveryPostcode();

<div class="d-flex flex-column gap-3">
    @if (markers) {
        <google-map mapId="map" height="250px" width="100%" [center]="center" [zoom]="zoom">
            @for (m of markers; track m) {
                <map-advanced-marker
                    #advancedMarker="mapAdvancedMarker"
                    [position]="m.position"
                    [options]="m.marker"></map-advanced-marker>
            }
        </google-map>
        @if (showEditFavourites) {
            <span class="small">
                Showing {{ markers.length }} branches, edit your favourite branches
                <a (click)="handleNavigate()" routerLink="/admin/integrations/wolseley/branches">here</a>.
            </span>
        }
    } @else if (showEditFavourites) {
        <span class="small">
            No branches found, edit your favourite branches
            <a (click)="handleNavigate()" routerLink="/admin/integrations/wolseley/branches">here</a>.
        </span>
    }

    @if (wolseleyStock) {
        <form [formGroup]="form" class="d-flex flex-column gap-3">
            <sf-switch
                label="Show unavailable products"
                inputId="showUnavailableProducts"
                formControlName="showUnavailableProducts" />
            <div class="table-responsive" style="margin-top: -0.5rem">
                <table
                    sfTable
                    small
                    [responsive]="true"
                    hover
                    align="middle"
                    class="mb-0 table-bordered table-primary text-center">
                    <thead sfTableColor="light">
                        <tr>
                            <th>Product</th>
                            <th>Available</th>
                            <th>Collection Date</th>

                            @if (deliveryPostcode) {
                                <th>Delivery Date</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (stock of wolseleyStock.dataArea.productAvailability.stockAvailability; track stock) {
                            <tr class="text-start table-success">
                                <td [colSpan]="4">
                                    <span class="fw-bold">{{ stock.branchName }} ({{ stock.branchCode }})</span>
                                </td>
                            </tr>
                            @for (product of stock.productDatas; track product.productCode) {
                                @let productQuantity =
                                    product.quantityAvailableAtBranch < 0 ? 0 : product.quantityAvailableAtBranch;

                                @if (
                                    showUnavailableProducts() ||
                                    product.earliestCollectionDate ||
                                    (deliveryPostcode && product.earliestDeliveryDate)
                                ) {
                                    <tr class="table-light">
                                        <td>{{ product.productCode }}</td>
                                        <td>{{ productQuantity }}</td>
                                        <td>{{ (product.earliestCollectionDate | date) ?? 'N/A' }}</td>

                                        @if (deliveryPostcode) {
                                            <td>{{ (product.earliestDeliveryDate | date) ?? 'N/A' }}</td>
                                        }
                                    </tr>
                                }
                            }
                        }
                    </tbody>
                </table>
            </div>
        </form>
    }
</div>
